import { type PropsWithChildren } from 'react';

import { Flex } from '@dynatrace/strato-components/layouts';

import { container } from './Icon.sty.js';

export const Icon = ({ children }: PropsWithChildren) => {
  if (children === undefined) {
    return null;
  }

  return children !== undefined ? (
    <Flex justifyContent="center" alignItems="center" className={container}>
      {children}
    </Flex>
  ) : null;
};

Icon['displayName'] = 'MeterBarLayout.Icon';
